// extracted by mini-css-extract-plugin
export default {"section":"About_section__U1YK1","textContainer":"About_textContainer__TgQec","title":"About_title__XSZdA","textStyle":"About_textStyle__tn99i","nameStyle":"About_nameStyle__uH8P8"};